import {Component} from "@angular/core";
import {CognitoCallback} from "../../../providers/cognito.service";
import {AlertController, NavController, NavParams} from "ionic-angular";
import {UserLoginService} from "../../../providers/userLogin.service";
import {LoginComponent} from "../login/login.component";
import {RegisterComponent} from "../register/register.component";

let passwordRegex = RegExp((/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/));


@Component({
    templateUrl: 'forgotPasswordStep2.html',
    selector: 'forgot-password-page ',
})
export class ForgotPasswordStep2Component implements CognitoCallback {
    passwordConfirm:string;
    verificationCode: string;
    email: string;
    password: string;

    constructor(public nav: NavController, public navParam: NavParams, public alertCtrl: AlertController, public userService: UserLoginService) {
        this.email = navParam.get("email");
    }

    onNext() {
        this.userService.confirmNewPassword(this.email, this.verificationCode, this.password, this);
    }

    cognitoCallback(message: string) {
        if (message != null) { //error
            this.doAlert("Verification Code", message);
        } else { //success
            this.doAlert("Password Reset Successful!", "")
            this.nav.push(LoginComponent);
        }
    }
    hasLowerCase(str) {
        return (str&&str.length)?(/[a-z]/.test(str)):false;
    }
    hasUpperCase(str) {
        return (str&&str.length)?(/[A-Z]/.test(str)):false;
    }
    hasNumber(str) {
        return (str&&str.length)?(/\d/.test(str)):false;
    }
    navToRegister() {
        this.nav.push(RegisterComponent);
    }
    passwordReady(p1, p2){
        return p1===p2 && passwordRegex.test(p1);
    }

    navToLogin() {
        this.nav.push(LoginComponent);
    }

    doAlert(title: string, message: string) {
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        });
        alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/auth/forgot-password/forgotPassword2.component.ts